import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GuestRole } from 'app/shared/models/guest-role.model';
import { SponsorService } from 'app/shared/services/sponsor.service';
import { Sponsor } from 'app/shared';

@Component({
  selector: 'app-sponsor-guest-table',
  templateUrl: './sponsor-guest-table.component.html',
  styleUrls: ['./sponsor-guest-table.component.scss'],
  standalone: false,
})
export class SponsorGuestTableComponent implements OnInit {
  guests!: GuestRole[];
  sponsorId!: number;
  guestCreator!: Sponsor;

  constructor(
    private route: ActivatedRoute,
    private sponsorService: SponsorService,
  ) {}

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      const idParam = params.get('sponsorId');
      if (!idParam) {
        console.error('sponsorId parameter is missing in the route');
        return;
      }
      this.sponsorId = parseInt(idParam);
      this.accountsCreatedBy(this.sponsorId);
      this.guestAccountCreator(this.sponsorId);
    });
  }

  accountsCreatedBy(id: number) {
    this.sponsorService.getGuestRolesBySponsorId(id).subscribe({
      next: (result: GuestRole[]) => {
        this.guests = result;
      },
      error: (err) => {
        console.error('Error fetching guest roles', err);
      },
    });
  }

  guestAccountCreator(id: number) {
    this.sponsorService.getSponsorById(id).subscribe({
      next: (result: Sponsor) => {
        this.guestCreator = result;
      },
      error: (err) => {
        console.error('Error fetching sponsor', err);
      },
    });
  }
}
